// Cloudflare R2 client helpers. Attachments are uploaded directly from the browser
// to R2 via a short-lived presigned PUT URL minted by /api/r2-presign (R2 credentials
// stay server-side). Public reads go through the configured r2.dev / custom-domain base.
//
// VITE_R2_PUBLIC_BASE_URL is the switch: when unset, the store falls back to Supabase
// Storage, so the app keeps working before R2 is configured.

const R2_BASE = (import.meta.env.VITE_R2_PUBLIC_BASE_URL || '').replace(/\/$/, '')

/** True when R2 is configured for this build. */
export const r2Enabled = () => !!R2_BASE

/** Absolute public URL for an object key (keys use URL-safe chars: uuids, digits, dots). */
export const r2PublicUrl = (key) => `${R2_BASE}/${key}`

/** Derive the object key from an R2 public URL (inverse of r2PublicUrl). null if not ours. */
export function r2KeyFromUrl(url) {
  if (!R2_BASE || !url || !url.startsWith(R2_BASE + '/')) return null
  try { return decodeURIComponent(url.slice(R2_BASE.length + 1).split('?')[0]) }
  catch { return url.slice(R2_BASE.length + 1).split('?')[0] }
}

/**
 * Ask the server for a presigned PUT URL (op 'put') or perform a server-side delete
 * (op 'delete'). The caller's Supabase access token authorizes the request.
 */
export async function r2Presign({ key, contentType, op = 'put', token }) {
  const res = await fetch('/api/r2-presign', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    body: JSON.stringify({ key, contentType, op }),
  })
  if (!res.ok) {
    let msg = `presign failed (${res.status})`
    try { msg = (await res.json()).error || msg } catch { /* non-json body */ }
    throw Object.assign(new Error(msg), { status: res.status })
  }
  return res.json()
}
